export default {
	// 企业列表
	laborEnt: {
		api: 'api/manage/labor/list',
		option: {
			label: 'entName',
			key: 'entCode'
		},
	},
	// 服务商列表
	// taxBase: {
	// 	api: 'api/manage/org/tax/list',
	// 	option: {
	// 		label: 'taxBaseName',
	// 		key: 'taxBaseCode'
	// 	},
	// },
	// 平台/机构/用工企业下的服务商列表
	// taxBase: {
	// 	api: 'api/manage/tax/select/list',
	// 	option: {
	// 		label: 'taxBaseName',
	// 		key: 'taxBaseCode'
	// 	},
	// },
	// 用工企业下的服务商列表
	taxBase: {
		api: 'api/manage/labor/taxInfo/page',
		option: {
			label: 'taxBaseName',
			key: 'taxBaseCode'
		},
	},
  // 用工企业选择下拉列表
	taxSelect: {
		api: 'api/manage/labor/tax/available/list',
		option: {
			label: 'taxBaseName',
			key: 'taxBaseCode'
		},
	},
  // 业务配置下服务商列表
  businessTaxBase: {
		api: 'api/manage/tax/business/list',
		option: {
			label: 'taxBaseName',
			key: 'taxBaseCode'
		},
	},
	// 代理商列表
	agent: {
		api: 'api/manage/agent/list',
		option: {
			label: 'agentName',
			key: 'agentCode'
		},
	},
	// 机构列表
	org: {
		api: 'api/manage/org/list',
		option: {
			label: 'orgName',
			key: 'orgCode'
		},
	},
	// 营销活动列表
	activity: {
		api: 'api/manage/activity/page',
		option: {
			label: 'activityName',
			key: 'activityCode'
		},
	},
	// 项目列表
	project: {
		api: 'api/manage/project',
		option: {
			label: 'projectName',
			key: 'projectCode'
		},
	},
	// 项目成员
	projectMember: {
		api: 'api/manage/project/member/page',
		option: {
			label: 'realName',
			key: 'id'
		},
	},
  // 个体户列表
  soleTrader: {
    api: 'api/manage/soleTrader/page',
    option: {
      label: 'realMainName',
      key: 'id'
    }
  },
  // 私车公用出租方列表
  carGroup: {
    api: '/api/manage/lessor/page',
    option: {
      label: 'groupName',
      key: 'id'
    }
  },
  // 考勤规则
  attendanceRules: {
    api: '/api/manage/attendance/rules/page',
    option: {
      label: 'rulesName',
      key: 'id'
    }
  },
  // 奖惩方案
  deductRules: {
    api: '/api/manage/attendance/deduct/rules/page',
    option: {
      label: 'rulesName',
      key: 'id'
    }
  },
  // 考勤人员
  attendancePerson: {
    api: '/api/manage/attendance/person/page',
    option: {
      label: 'realName',
      key: 'id'
    }
  },
  // 考勤项目
  attendanceProject: {
    api: '/api/manage/project/attendance/project',
    option: {
      label: 'projectName',
      key: 'projectCode'
    }
  },
  // 项目岗位
  projectPost: {
    api: '/api/manage/project/post',
    option: {
      label: 'postName',
      key: 'id'
    }
  },
  // 参保地城市
  insuredCities: {
    api: '/api/manage/social/insurance/policy/published/city/list',
    option: {
      label: 'cityName',
      key: 'cityCode'
    }
  }
}

export function	dedupeByKey(arr, key) {
  return Array.from(
    arr.reduce((map, item) => map.set(item[key], item), new Map())
  ).map(([_, val]) => val);
}